<template>
  <!-- Other details input -->
  <div>
    <v-list-item @click.stop="onDialog" link v-if="!hideTitle">
      <v-list-item-title>その他経緯表入力</v-list-item-title>
    </v-list-item>
    <v-dialog v-model="dialogForm" persistent max-width="800px">
      <v-card>
        <v-form ref="form">
          <v-card-title>その他経緯表入力</v-card-title>
          <v-card-text class="container grid-list-md">
            <v-layout wrap>
              <!-- kind -->
              <v-flex xs12>
                <v-select v-model="dataHistory.kind" :items="kindTorikumis" :rules="rules.kindTorikumi" item-text="label"
                  item-value="value" label="取組区分" @change="changeKind"></v-select>
              </v-flex>
              <!-- date -->
              <v-flex xs4>
                <v-menu :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px"
                  min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="computedDateFormatted" :rules="rules.target_date" readonly
                      :label="dataHistory.kind == 101 ? '契約日' : '実施日'" append-icon="mdi-calendar" persistent-hint
                      v-bind="attrs" v-on="on" width="120px">
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="dataHistory.target_date"
                    :day-format="(target_date) => new Date(target_date).getDate()" no-title></v-date-picker>
                </v-menu>
              </v-flex>
              <!-- time -->
              <v-flex xs4>
                <v-dialog ref="dialog1" v-model="timePick['target_time']" :return-value.sync="dataHistory.target_time"
                  persistent width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="dataHistory.target_time" :rules="rules.target_time" label="実施時刻" readonly
                      v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-time-picker v-if="timePick['target_time']" v-model="dataHistory.target_time" full-width scrollable
                    format="24hr" @change="changeTimeStart">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="timePick['target_time'] = false">
                      Cancel
                    </v-btn>
                    <v-btn text color="primary" @click="saveTimeStart">
                      OK
                    </v-btn>
                  </v-time-picker>
                </v-dialog>
              </v-flex>
              <v-flex xs4>
                <v-select v-model="dataHistory.counselor_id" :items="counselors" :rules="rules.counselor" item-text="name"
                  item-value="id" label="実施担当">
                  <template v-slot:item="{ item, attrs, on }">
                    <v-list-item v-on="on" v-bind="attrs" :class="{'d-none': !(item.resignation_date == null || moment(item.resignation_date).format('YYYY/MM/DD') > moment().format('YYYY/MM/DD'))}">
                        <v-list-item-title>
                          {{ item.name }}
                        </v-list-item-title>
                    </v-list-item>
                  </template>
                </v-select>
              </v-flex>
              <!-- <template v-if="dataHistory.kind == visitCounseling">
                <v-flex xs4>
                  <v-select v-model="dataHistory.status" :items="status" :rules="rules.status" item-text="text"
                    item-value="value" label="状態"></v-select>
                </v-flex>
                <v-flex xs4>
                  <v-select v-model="dataHistory.option.isPay" :items="statusPayments" :rules="rules.statusPayments"
                    item-text="label" item-value="value" label="入金確認済"></v-select>
                </v-flex>
                <v-flex xs4>
                  <v-text-field v-model="dataHistory.option.destination" :rules="rules.destination" type="text"
                    label="訪問先">
                  </v-text-field>
                </v-flex>
              </template>
              <template v-else>
                <v-flex xs4>
                  <v-select v-model="dataHistory.status" :items="status" :rules="rules.status" item-text="text"
                    item-value="value" label="状態"></v-select>
                </v-flex>
                <v-flex xs4>
                  <v-select v-model="dataHistory.option.isPay" :items="statusPayments" :rules="rules.statusPayments"
                    item-text="label" item-value="value" label="入金確認済"></v-select>
                </v-flex>
                <v-flex xs4 v-if="dataHistory.kind == womanFirst || dataHistory.kind == advise">
                  <v-select v-model="dataHistory.booth_no_id" :items="boothNos" :rules="rules.boothNo"
                    item-text="booth_no" item-value="id" label="ブース№"></v-select>
                </v-flex>
              </template> -->
              <v-flex xs4 v-if="dataHistory.kind == womanFirst || dataHistory.kind == advise">
                <v-select v-model="dataHistory.booth_no_id" :items="boothNos" :rules="rules.boothNo" item-text="booth_no"
                  item-value="id" label="ブース№"></v-select>
              </v-flex>
              <v-flex xs6 v-if="!kindNotCustomers.includes(dataHistory.kind)">
                <v-text-field v-model="phone" :rules="rules.phone" @blur="apiPhone($event)" ref="phone" type="text"
                  label="携帯番号" :readonly="customerFromHistory"></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="!kindNotCustomers.includes(dataHistory.kind)">
                <v-autocomplete v-model="family_name" :rules="rules.family_name" label="会員名" @keydown="focusCustomerName"
                  @update:search-input="debounce" @input="inputCustomerName" :items="itemFamilyNames" @blur="blurName"
                  :readonly="customerFromHistory"></v-autocomplete>
              </v-flex>
              <v-flex xs4 v-if="dataHistory.kind == visitCounseling">
                <v-text-field v-model="dataHistory.option.destination" :rules="rules.destination" type="text" label="訪問先">
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea 
                  label="メモ" 
                  v-model="dataHistory.note" 
                  :rules="rules.note"
                  :rows="3"
                  @input="onMemoInput"
                  @click="onMemoClick"
                  ref="memoTextarea"
                  class="memo-textarea"
                > 
                </v-textarea>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn width="132" class="info" @click="submit">登録</v-btn>
            <v-btn width="132" class="secondary" @click="closeDialog">戻る</v-btn>
            <v-btn width="132" class="error" @click="clearDataDialog" v-if="typeSubmit == 'update'">削除</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <MemoEditorDialog
      :visible.sync="memoDialog"
      v-model="dataHistory.note"
      :rules="rules.note"
    />
  </div>
</template>
<script>
import CUSTOMER from "@/consts/customer.js";
import moment from "moment";
import constants from '@/consts/constants.js'
import { required, inArray, date, max, phone, digits } from '@/utilities/validation.js';
import MemoEditorDialog from '@/components/common/MemoEditorDialog.vue'

export default {
  title: "OtherHistoryTable",
  name: "OtherHistoryTable",
  components: { MemoEditorDialog },
  props: ["date", "dialogCV", 'boothNos', 'counselors', 'historyData', 'showFormOtherHistory', 'hideTitle', 'valueKindForForm', 'shop_id', 'customer', 'isLedgerScreen'],
  data: function () {
    const kindTorikumis = CUSTOMER.KIND_TORIKUMIS
    const statusPayments = CUSTOMER.STATUS_PAYMENTS
    const visitCounseling = CUSTOMER.EXEC_KIND.VAL.VISIT_COUNSELING
    const womanFirst = CUSTOMER.EXEC_KIND.VAL.WOMAN_FIRST
    const advise = CUSTOMER.EXEC_KIND.VAL.ADVISE
    const kindNotCustomers = [
      CUSTOMER.EXEC_KIND.VAL.USAGE_PROHIBITED,
      CUSTOMER.EXEC_KIND.VAL.ADVISE,
    ]
    const notMemberCustomer = CUSTOMER.NOT_MEMBER_CUSTOMER

    return {
      // validate
      rules: {
        kindTorikumi: [
          (v) => required(v),
          (v) => inArray(v, kindTorikumis.map(item => item.value)),
        ],
        target_date: [
          (v) => required(v),
          (v) => date(v),
        ],
        target_time: [
          (v) => required(v),
        ],
        counselor: [
          (v) => required(v),
        ],
        status: [
          (v) => required(v),
        ],
        statusPayments: [
          (v) => required(v),
          (v) => inArray(v, statusPayments.map(item => item.value)),
        ],
        note: [
          (v) => max(v, 1000),
        ],
        boothNo: [
          (v) => required(v),
        ],
        phone: [
          (v) => required(v),
          (v) => phone(v),
          (v) => digits(v, 13),
        ],
        family_name: [
          (v) => required(v),
        ],
      },

      dataHistory: {
        customer_id: null,
        kind: null,
        target_date: this.date,
        target_time: null,
        target_time_end: null,
        counselor_id: null,
        status: 2,
        type: constants.TYPE_FORM.OTHER_HISTORY_TABLE_INPUT,
        note: '',
        option: {
          destination: '',
          isPay: false,
          shop_id: this.shop_id
        },
      },
      family_name: "",
      family_name_old: "",
      customers: '',
      itemFamilyNames: [],
      isFamilyName: false,
      phone: "",
      kindTorikumis,
      timePick: [],
      status: CUSTOMER.STATUS_ORTHER_HISTORY.LIST,
      dialogForm: false,
      statusPayments,
      visitCounseling,
      typeSubmit: null,
      womanFirst,
      advise,
      isValueForm: [201, 501, 101, 102, 1, 2, 3, 4, 9999, 13, 111, 1001],
      addTimeWithKind: 0,
      customerFromHistory: false,
      kindNotCustomers: kindNotCustomers,
      notMemberCustomer: notMemberCustomer,
      moment: moment,
      isMemoFocused: false,
      memoDialog: false,
    }
  },

  computed: {
    computedDateFormatted() {
      return this.dataHistory.target_date ? this.formatDate(this.dataHistory.target_date) : this.formatDate(this.date)
    },
  },
  watch: {
    showFormOtherHistory: function (newDialog) {
      this.dialogForm = newDialog
    },
    historyData: function (newDataHistory) {
      if (newDataHistory.type == constants.TYPE_FORM.OTHER_HISTORY_TABLE_INPUT && this.valueKindForForm.length == 0) {
        this.dataHistory.kind = newDataHistory.kind
        this.dataHistory.target_date = this.formatDateSlash(newDataHistory.target_date)
        this.dataHistory.target_time = newDataHistory.target_time
        this.dataHistory.customer_id = newDataHistory.customer_id
        this.dataHistory.target_time_end = newDataHistory.target_time_end
        this.dataHistory.status = newDataHistory.status
        this.dataHistory.booth_no_id = newDataHistory.booth_no_id
        // this.dataHistory.option = newDataHistory.option
        this.dataHistory.option.decCO = newDataHistory.option.decCO
        this.dataHistory.option.follTel = newDataHistory.option.follTel
        this.dataHistory.option.isPay = newDataHistory.option.isPay
        this.dataHistory.option.letter = newDataHistory.option.letter
        this.dataHistory.option.matchRes = newDataHistory.option.matchRes
        this.dataHistory.option.matchTel = newDataHistory.option.matchTel
        this.dataHistory.option.payVal = newDataHistory.option.payVal
        this.dataHistory.option.resTel = newDataHistory.option.resTel
        this.dataHistory.option.result = newDataHistory.option.result
        this.dataHistory.option.targets = newDataHistory.option.targets
        this.dataHistory.option.verTel = newDataHistory.option.verTel
        this.dataHistory.option.destination = newDataHistory.option.destination
        this.dataHistory.option.isPay = newDataHistory.option.isPay
        this.dataHistory.counselor_id = newDataHistory.counselor_id
        this.dataHistory.note = newDataHistory.note
        this.dataHistory.option.shop_id = newDataHistory.option.shop_id
        this.family_name = newDataHistory.customer_id == this.notMemberCustomer ? null : newDataHistory.family_name + newDataHistory.given_name
        this.family_name_old = this.family_name
        this.itemFamilyNames = [this.family_name]
        this.phone = newDataHistory.customer_id == this.notMemberCustomer ? null : newDataHistory.phone
        this.typeSubmit = 'update'
      }
    },
    valueKindForForm: function (newValueKindForForm) {
      if (newValueKindForForm) {
        if (this.customer.id != CUSTOMER.NOT_MEMBER_CUSTOMER && this.customer.id != CUSTOMER.MEMBER_CONNECT) {
          this.customerFromHistory = true
          this.family_name = this.customer.family_name + this.customer.given_name
          this.itemFamilyNames = [this.customer.family_name + this.customer.given_name]
          this.phone = this.customer.phone_number
        } else {
          this.family_name = ''
          this.phone = ''
        }

        let customerId = null;
        if (!this.kindNotCustomers.includes(newValueKindForForm)) {
          customerId = this.customer.id
        }

        this.dataHistory = {
          customer_id: customerId,
          kind: newValueKindForForm,
          target_date: this.date,
          target_time: null,
          target_time_end: null,
          counselor_id: null,
          status: 2,
          type: constants.TYPE_FORM.OTHER_HISTORY_TABLE_INPUT,
          note: '',
          booth_no_id: null,
          option: {
            destination: '',
            isPay: false,
            shop_id: this.shop_id
          },
        }
        this.changeKind()
        this.typeSubmit = ''
        if (this.isValueForm.includes(newValueKindForForm)) {
          this.$refs.form?.resetValidation()
        }
      }
    },
    date: function (newDate) {
      if (newDate) {
        this.dataHistory.target_date = newDate
      }
    },
  },
  methods: {
    onDialog() {
      this.$emit('closeMenu')
      this.dialogForm = true
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${year}/${month}/${day}`
    },
    formatDateSlash(date) {
      if (!date) return null

      const [year, month, day] = date.split('/')
      return `${year}-${month}-${day}`
    },
    submit() {
      const validate = this.$refs.form.validate()
      if (validate == false) {
        return
      }
      if (this.customer && this.typeSubmit != 'update' && !this.dataHistory.customer_id) {
        this.dataHistory.customer_id = this.customer.id
      }
      if (this.typeSubmit == 'update') {
        this.$axios.put(`/api/v1/customer/${this.dataHistory.customer_id}/history/${constants.TYPE_FORM.OTHER_HISTORY_TABLE_INPUT}`, { historyId: this.historyData.id, historyData: this.dataHistory })
          .then(() => {
            this.$emit('refreshListHistory')
            this.$emit('closeFormOtherHistory')
          })
          .catch((error) => {
            console.log("Error : " + error);
          });

      } else {
        this.$axios.post("/api/v1/customer/history", { dataHistory: this.dataHistory })
          .then(() => {
            this.closeDialog()
            this.$emit('refreshCalendar')
            if (this.valueKindForForm) {
              this.$emit('refreshListHistory')
              this.$emit('closeFormOtherHistory')
            }
            if (this.isLedgerScreen) {
              this.$emit('refreshLedgerData')
            }
          })
          .catch((error) => {
            console.log("Error : " + error);
          });
      }
    },
    getMonth() {
      return moment(this.value).format("MM")
    },
    clearDataDialog() {
      if (this.typeSubmit == 'update') {
        if (this.historyData.type == constants.TYPE_FORM.OTHER_HISTORY_TABLE_INPUT && this.valueKindForForm.length == 0) {
          this.dataHistory.kind = this.historyData.kind
          this.dataHistory.booth_no_id = this.historyData.booth_no_id
          this.dataHistory.target_date = this.formatDateSlash(this.historyData.target_date)
          this.dataHistory.target_time = this.historyData.target_time
          this.dataHistory.status = this.historyData.status
          this.dataHistory.option.decCO = this.historyData.option.decCO
          this.dataHistory.option.follTel = this.historyData.option.follTel
          this.dataHistory.option.isPay = this.historyData.option.isPay
          this.dataHistory.option.letter = this.historyData.option.letter
          this.dataHistory.option.matchRes = this.historyData.option.matchRes
          this.dataHistory.option.matchTel = this.historyData.option.matchTel
          this.dataHistory.option.payVal = this.historyData.option.payVal
          this.dataHistory.option.resTel = this.historyData.option.resTel
          this.dataHistory.option.result = this.historyData.option.result
          this.dataHistory.option.targets = this.historyData.option.targets
          this.dataHistory.option.verTel = this.historyData.option.verTel
          this.dataHistory.option.destination = this.historyData.option.destination
          this.dataHistory.option.isPay = this.historyData.option.isPay
          this.dataHistory.counselor_id = this.historyData.counselor_id
          this.dataHistory.note = this.historyData.note
          this.dataHistory.shop_id = this.historyData.option.shop_id
          this.phone = this.historyData.phone
          this.family_name = this.historyData.family_name + this.historyData.given_name
          this.itemFamilyNames = [this.family_name]
          this.dataHistory.customer_id = this.historyData.customer_id
        }
      } else {
        this.dataHistory = {
          customer_id: null,
          kind: this.valueKindForForm,
          target_date: this.date,
          target_time: null,
          target_time_end: null,
          counselor_id: null,
          status: 2,
          type: constants.TYPE_FORM.OTHER_HISTORY_TABLE_INPUT,
          note: '',
          booth_no_id: null,
          option: {
            destination: '',
            isPay: false,
            shop_id: this.shop_id
          }
        }
        this.family_name = ""
        this.phone = null
        if (this.customerFromHistory) {
          this.dataHistory.kind = this.valueKindForForm
          this.family_name = this.customer.family_name + this.customer.given_name
          this.itemFamilyNames = [this.customer.family_name + this.customer.given_name]
          this.phone = this.customer.phone_number
        }
        this.$refs.form?.resetValidation()
      }
    },
    closeDialog() {
      this.dialogForm = false
      this.clearDataDialog()
      this.$emit('closeMenu')
      this.$emit('closeFormOtherHistory')
    },
    changeKind() {
      this.$axios
        .get("/api/v1/date-setting/" + this.dataHistory.kind)
        .then((response) => {
          this.addTimeWithKind = response.data.kind.date_add
          if (this.dataHistory.target_time != "") {
            const startAt = moment(this.dataHistory.target_time, 'HH:mm')
            this.dataHistory.target_time_end = startAt.isBefore(moment('23:10', 'HH:mm')) ? startAt.add(this.addTimeWithKind, 'minutes').format('HH:mm') : '23:59';
          }
        })
        .catch((error) => {
          console.log("Error : " + error);
        });
    },
    changeTimeStart() {
      const startAt = moment(this.dataHistory.target_time, 'HH:mm')
      this.dataHistory.target_time_end = startAt.isBefore(moment('23:10', 'HH:mm')) ? startAt.add(this.addTimeWithKind, 'minutes').format('HH:mm') : '23:59';
      this.minTime = moment(this.dataHistory.target_time, 'HH:mm').add(30, 'minutes').format('HH:mm')
    },
    saveTimeStart() {
      this.changeTimeStart(this.dataHistory.target_time)
      this.$refs.dialog1.save(this.dataHistory.target_time > this.dataHistory.target_time_end ? this.dataHistory.target_time_end : this.dataHistory.target_time)
    },
    apiPhone(e) {
      this.isFamilyName = false;

      const validate = this.$refs.phone.validate()
      if (validate == false) {
        this.phoneOld = e.target.value
        this.family_name = ''
        this.family_name_old = ''
        this.itemFamilyNames = []
        return
      }
      this.$axios
        .get("/api/v1/customer/phone_number/" + e.target.value)
        .then((response) => {
          const customer = response.data.customer
          if (customer.id != undefined) {
            this.family_name = customer.family_name + customer.given_name
            this.family_name_old = this.family_name;
            this.itemFamilyNames = [this.family_name]
            this.dataHistory.customer_id = customer.id || CUSTOMER.NOT_MEMBER_CUSTOMER
          } else {
            alert('対象者が存在しません')
            this.phone = ''
            this.family_name = ''
            this.itemFamilyNames = []
            return false;
          }
        })
        .catch((error) => {
          console.log("Error : " + error);
        });
    },
    blurName() {
      this.itemFamilyNames = [this.family_name_old]
      this.family_name = this.family_name_old
      this.isFamilyName = false;
    },
    async debounce(e, timeout = 300) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => { this.searchInputCustomerName(e) }, timeout);
    },
    focusCustomerName() {
      this.isFamilyName = true;
    },
    async searchInputCustomerName(e) {
      if (!this.isFamilyName || e == null || e == '') {
        return
      }

      const url = '/api/v1/customer/by-name/' + e
      const response = await this.$axios.get(url)
      this.customers = response.data.customers
      this.itemFamilyNames = this.customers.map(item => {
        return item.family_name + item.given_name + ' (' + item.family_name_kana + item.given_name_kana + ')'
      })
    },
    async inputCustomerName(e) {
      if (e == null) {
        return
      }

      const customers = await this.customers.find(item => e == item.family_name + item.given_name + ' (' + item.family_name_kana + item.given_name_kana + ')')

      if (Object.keys(customers).length > 0) {
        this.itemFamilyNames = await [customers.family_name + customers.given_name]
        this.family_name = await customers.family_name + customers.given_name
        this.family_name_old = await customers.family_name + customers.given_name
        this.phone = await customers.phone_number;
        this.phoneOld = await customers.phone_number
        this.genderCustomer = await customers.gender;
        this.dataHistory.customer_id = await customers.id
      }

      this.isFamilyName = false;
    },
    openMemoModal() {
      if (this.memoDialog) return;
      this.memoDialog = true;
      this.$nextTick(() => {
        if (this.$refs.memoTextarea && this.$refs.memoTextarea.$el) {
          const ta = this.$refs.memoTextarea.$el.querySelector('textarea');
          ta && ta.blur();
        }
      });
    },
    checkMemoContentAndOpenModal(content, maxLines = 3) {
      if (!content || !content.trim()) return;
      
      const explicitLineCount = content.split(/\r?\n/).length;
      
      if (explicitLineCount > maxLines) {
        this.openMemoModal();
        return;
      }
      
      this.$nextTick(() => {
        const textarea = this.$refs.memoTextarea && this.$refs.memoTextarea.$el
          ? this.$refs.memoTextarea.$el.querySelector('textarea')
          : null;
        
        if (textarea) {
          const originalHeight = textarea.style.height;
          textarea.style.height = 'auto';
          
          const lineHeight = parseInt(window.getComputedStyle(textarea).lineHeight) || 24;
          const visualLines = Math.ceil(textarea.scrollHeight / lineHeight);
          
          textarea.style.height = originalHeight;
          
          if (visualLines > maxLines) {
            this.openMemoModal();
          }
        }
      });
    },
    onMemoInput(val) {
      const content = typeof val === 'string' ? val : (this.dataHistory.note || '');
      this.checkMemoContentAndOpenModal(content, 3);
    },
    onMemoClick() {
      const content = this.dataHistory.note || '';
      this.checkMemoContentAndOpenModal(content, 3);
    },
  },
};
</script>

<style scoped>
/* Clickable textarea styling */
.clickable-textarea {
  cursor: pointer;
}

.memo-modal-textarea ::v-deep .v-text-field__slot textarea {
  min-height: 120px !important;
  max-height: unset !important;
  line-height: 24px !important;
  padding: 12px !important;
  font-size: 14px !important;
  overflow-y: auto !important;
  resize: vertical !important;
}
</style>
  